// Default configuration values

import type { PrinterConfig, StoreInfo, BillCounterConfig } from './types'

export const DEFAULT_PRINTER_CONFIG: PrinterConfig = {
  deviceName: 'Serial Printer',
  serialPort: '',  // 설정에서 선택 필요
  baudRate: 9600,
  dataBits: 8,
  parity: 'none',
  stopBits: 1,
  paperWidth: 58,
  charactersPerLine: 32
}

export const DEFAULT_STORE_INFO: StoreInfo = {
  name: 'ABC Currency Exchange',
  address: 'a108-1-ho, 3 Chungmu-ro, Jung-gu, Seoul',
  phone: '02-2268-2001',
  businessNumber: '811-85-02934'
}

export const DEFAULT_COUNTER_CONFIG: BillCounterConfig = {
  serialPort: '',
  baudRate: 19200,
  dataBits: 8,
  parity: 'none',
  stopBits: 1,
  enabled: false
}

// Web App URL configuration
export const WEB_APP_CONFIG = {
  productionUrl: 'https://pos.abcpay.co.kr',
  developmentUrl: 'https://dev.pos.abcpay.co.kr',
  connectionTimeout: 10000, // 10 seconds
}
